'use client'
import * as React from 'react'
import { formatDataFor } from './format-data'
import { ShopTheLook } from './shop-the-look'

// A single live engine instance for the page hero — a real ShopTheLook on a
// real industry, so the hero shows the actual product (not a fake video still
// or stock photo). Kept as its own tiny client wrapper so the page can stay a
// server component and the hero engine ships its own chunk.
export function FormatHeroDemo({ slug }: { slug: string }) {
  const data = React.useMemo(() => formatDataFor(slug), [slug])
  if (!data) return null
  return <ShopTheLook data={data} />
}
